<template lang="pug">
section.sig
    section.sig__pesquisa
        PesquisaInteligente(
            :key='keyBarraPesquisa',
            @representante-selecionado='mostrarTerritoriosRepresentante',
            @territorio-selecionado='mostrarTerritorio',
            @municipio-selecionado='mostrarLocalidade'
        )

    section
        .div-loading(v-if='loadingVisivel')
            span Carregando territórios
            i.ml-2.el-icon-loading

    section.sig__mapa.lyra__cartao
        mapa(
            ref='map',
            idMapa='MapaSig',
            :mapLayersConfigs='camadasMapa',
            :mapConfig='configuracoesMapa',
            :menuMaior='true',
            :atualizarMapa='false'
        )
</template>

<script>
import Mapa from '@/components/mapaLeafletClusters.vue';
import PesquisaInteligente from '@/components/sig/PesquisaInteligente';
import TerritorioService from '@/services/TerritorioService';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import PopupMapaTerritorio from '@/components/territorio/PopupMapaTerritorio.vue';
import InstanciarComponente from '@/utils/InstanciarComponenteVue';
import { mapState } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'index',

    components: {
        Mapa,
        PesquisaInteligente
    },

    computed: {
        ...mapState(['usuarioLogado'])
    },

    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    buscarCarControl: true
                },
                inspecionar: true,
                diagnostico: true
            },
            territorios: [],
            territoriosBuffer: [],
            idLocalidade: null,
            keyBarraPesquisa: 42,
            pesquisando: false,
            loadingVisivel: false
        };
    },

    async mounted() {
        this.idLocalidade = this.$route.params.idMunicipio;
        if (this.idLocalidade) {
            await this.mostrarLocalidade(this.idLocalidade);
        } else {
            setTimeout(() => {
                this.buscarTerritorios();
            }, 1000);
        }
    },

    created() {
        if (this.usuarioLogado.paisGrupo !== AmbientesEmpresas.BRASIL) {
            this.configuracoesMapa.controls.buscarCarControl = false;
        }
    },

    methods: {
        async buscarTerritorios() {
            try {
                this.loadingVisivel = true;
                const response = await TerritorioService.findByMapaHome();
                this.territorios = response.data;
                this.territoriosBuffer = response.data;
                this.mostrarTerritorios();
                this.loadingVisivel = false;
            } catch (error) {
                this.loadingVisivel = false;
                this.$notify.error({
                    message: 'Ocorreu um erro ao buscar os territórios.'
                });
            }
        },

        mostrarTerritorios() {
            this.camadasMapa = [];

            this.territorios.forEach(
                ({ id, centroide }) => {
                    this.camadasMapa.push({
                        name: 'centroid' + id,
                        geoJson: centroide,
                        acaoClick: () => this.mostrarDetalhesTerritorio(id)
                    });
                }
            );
        },

        criarPopup({ id, nome, representantes, localidade }) {
            let representanteLabel = 'Pessoa';
            let representanteLista = [];

            if (representantes) {
                representantes = representantes.split(',');

                if (representantes.length > 1) {
                    representanteLabel = 'Pessoas';
                }

                representantes.forEach(nome => {
                    representanteLista.push(nome.trim());
                });
            } else {
                representanteLista.push('Nenhuma pessoa vinculada');
            }

            const data = {
                id,
                nome,
                representante: {
                    titulo: representanteLabel,
                    representantes: representanteLista
                },
                localidade
            };
            const instance = InstanciarComponente(PopupMapaTerritorio, {
                mapa: this.$refs.map.mapa,
                data
            });
            return instance.$el;
        },

        async mostrarTerritoriosRepresentante(id) {
            this.pesquisando = true;
            try {
                const { data } =
                    await TerritorioService.buscarTerritoriosPorIdRepresentante(
                        id
                    );
                this.territorios = data;

                if (this.territorios.length === 0) {
                    this.$notify.info({
                        message: this.$t(`mensagens.menuSig.pesquisaInteligente.territorioNaoEcontradoPorPessoa`)
                    });
                } else if (this.territorios.length > 1) {
                    this.mostrarTerritorios();
                } else {
                    this.mostrarTerritorio(this.territorios[0].id);
                }
                this.pesquisando = false;
            } catch (error) {
                this.pesquisando = false;
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao buscar os territórios da pessoa'
                });
            }
        },

        mostrarTerritorio(id) {
            this.pesquisando = true;
            this.camadasMapa = [];

            const territorio = this.territoriosBuffer.find(t => t.id === Number(id));

            if (territorio) {
                const geoJson = territorio.centroide;
                this.camadasMapa.push({
                    name: 'centroid' + territorio.id,
                    geoJson
                });

                this.mostrarDetalhesTerritorio(territorio.id);
            } else {
                this.$notify.error({
                    message: 'Território não encontrado.'
                });
            }
        },

        async mostrarDetalhesTerritorio(id) {
            const existeTerritorio = this.camadasMapa.some(
                ({ name }) => name === 'territorioExibido' + id
            );

            if (!existeTerritorio) {
                try {
                    const { data } =
                        await TerritorioService.findGeometriaByIdTerritorio(id);
                    this.camadasMapa.push({
                        name: 'territorioExibido' + id,
                        geoJson: data.geometria,
                        style: getEstiloGeometria('area')
                    });
                    this.camadaCentralizadaNome = 'territorioExibido' + id;
                } catch (error) {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao exibir o território'
                    });
                }
            }

            this.$nextTick(() => {
                const marcadorConfig = this.camadasMapa.find(
                    ({ name }) => name === 'centroid' + id
                );

                if (marcadorConfig) {
                    const territorio = this.territorios.find(t => t.id === id);
                    const popupContent = this.criarPopup(territorio);
                    marcadorConfig.popup = popupContent;

                    const markerLayer = this.$refs.map.getLayerByName(
                        marcadorConfig.name
                    );

                    if (markerLayer) {
                        markerLayer.bindPopup(popupContent, {
                            autoClose: false,
                            closeOnClick: false
                        });
                        markerLayer.openPopup();
                    }
                }
            });

            this.pesquisando = false;
        },

        async mostrarLocalidade(id) {
            this.pesquisando = true;
            this.camadasMapa = [];

            try {
                const { data } =
                    await TerritorioService.findGeometriaByIdLocalidade(id);

                this.camadasMapa.push({
                    name: 'localidade' + id,
                    geoJson: data.geometria,
                    style: getEstiloGeometria('localidade')
                });
                this.pesquisando = false;
            } catch (error) {
                this.pesquisando = false;
                this.$notify.error({
                    message: 'Ocorreu um erro ao buscar dados da localidade'
                });
            }
        },

        limparPesquisa() {
            this.pesquisando = false;
            this.keyBarraPesquisa += 1;
            this.territorios = this.territoriosBuffer;
            this.mostrarTerritorios();
        }
    }
};
</script>

<style lang="scss" scoped>
.sig {
    padding: 20px;
}

.sig__mapa {
    border-radius: 5px;
    overflow: hidden;
    height: calc(100vh - 171px);

    position: relative;
    z-index: 1;
}

.sig__pesquisa {
    margin-bottom: 20px;
}

.el-icon-delete.lyra__cartao {
    width: 40px;
    display: grid;
    place-items: center;
    cursor: pointer;
}

.div-loading {
    display: flex;
    justify-content: right;
    color: var(--primary);
    font-size: 14px;
    margin-bottom: 10px;
    height: 14px;
}
</style>
